/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import UserStore from 'stores/UserStore';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import Loading from 'components/Loading/Loading';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  userStore: UserStore,
  actionDrawerStore: TypeActionDrawerStore,
|};

@translate()
@inject('actionDrawerStore', 'authenticationStore', 'userStore')
@observer
export default class LoginAsUserSuccess extends React.Component<*> {
  componentDidMount() {
    setTimeout(() => {
      // Redirect to dashboard after 1000ms
      window.location.href = '/dashboard';
    }, 1000);
  }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { userStore }: TypeProps = this.props;
    const user = userStore.activeUser;

    return userStore.userLoaded ? (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:accounts.login_as_user_title')}</h3>
            <p>{t('general:accounts.messages.login_as_user_message')}</p>
          </div>
          {user && (
            <div className={styles['loginasuser-account-details']}>
              <ul>
                <li>{`${user.first_name} ${user.last_name}`}</li>
                <li>
                  <b>{t('general:roles.labels.current_role')}</b>:{' '}
                  {t(`general:roles.${user.role_id}`)}
                </li>
              </ul>
            </div>
          )}
        </div>
        <div className={styles['action-drawer-actions']}>Redirecting...</div>
      </React.Fragment>
    ) : (
      <Loading />
    );
  }
}
